import { render } from "./AddUser.vue?vue&type=template&id=2823669c"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"
script.render = render

export default script